import { FC } from "react"
import { observer } from "mobx-react-lite"
import { Form, Input, Button } from "semantic-ui-react"
import FsVM from "./FsVM"




interface Props {
    viewModel: FsVM
}
const Fs: FC<Props> = ({ viewModel }) => {
    return (
        <div>
            <div>

                <Form>

                    <Input
                        onChange={e => viewModel.setFormFile(e.target.files.item(0))}
                        type="file"
                    />
                    <Button primary content="Загрузить" onClick={() => viewModel.sendFile()} />
                </Form>
                <Form>

                    <Input
                        onChange={e => viewModel.setFormFile(e.target.files.item(0))}
                        type="file"
                    />
                    <Button secondary content="Загрузить beta" onClick={() => viewModel.sendFileBeta()} />
                </Form>
            </div>

            <div>
                <Button secondary content="ping" onClick={() => viewModel.testWs()} />
            </div>
        </div>
    )
}

export default observer(Fs);